import React, { Component } from 'react';
import './SignupSuccess.scss';
import successIcon from '../../../assets/icons/success_tick_icon.svg';
import { getParameterByName } from '../../../utils/WindowHelper';
import { SignupSurvey } from '../SignupSurvey';

export class SignupSuccess extends Component<ISignupSuccessProps, any> {
  onLoginClicked = () => {
    window.location.href = this.props.nextStep;
  };

  render() {
    const successProps = this.props;
    const tags = getParameterByName('tags');

    return (
      successProps && (
        <>
          <div className={'hatters-flex-column-container'}>
            <span className={'flex-spacer-small'} />

            <img src={successIcon} className={'signup-success-icon'} alt={'Signup success icon'} />
            <div className={'hatters-title signup-success-title'}>Success!</div>
            <div className={'hatters-description-normal'}>Your HAT PDA with the following URL has been created:</div>

            <div className={'hatters-hat-name success-signup-hat-name'}>{successProps.hatDomain}</div>

            <button
              className="hatters-btn hatters-btn-accent signup-success-btn-login"
              onClick={() => this.onLoginClicked()}
            >
              Log me in
            </button>

            {tags && <SignupSurvey />}

            <span className={'flex-spacer-large'} />
          </div>
        </>
      )
    );
  }
}

interface ISignupSuccessProps {
  hatDomain: string;
  nextStep: string;
}
